import { Environment } from "./Interfaces/environment.model";

export const environment: Environment = {
  production: false,
  isStaging: false,
  name: "dev-server",
  primaryUrl: "https://dev.api.nutrientplaner.ru",
  primaryApiUrl: "https://dev.api.nutrientplaner.ru/api",
  primaryApiDomain: "dev.api.nutrientplaner.ru",
  apiDomain: "https://dev.nutrientplaner.ru",
  patientProfileDomain: "https://dev.nutrientplaner.ru",
  eventMonitoringDomain: "https://api.nutrientplaner.ru",
  amplitude: {
    apiKey: "000000",
    apiEndpoint: "api.nutrientplaner.ru",
  },
  log: {
    routing: false,
    level: "debug",
    loggers: {},
  },

  googleTagManager: {
    id: "GTM-5VVK2GK",
  },
  googleAnalytics: {
    id: "G-CX1QQCK5VN",
  },
  yandexMetrika: {
    id: 70489375,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  },
  experrto: {
    id: "4cbbd5f5339767a8c91ff4932393291a06a497e0",
  },
  locales: ["ru", "en"],
  defaultLocale: "ru",
  fallbackLang: "en",
  questionnaireDiaryInstructionLink:
    "https://drive.google.com/file/d/14TT8RzWN7pqXb5P8Vc18C__6WuJLyWqx/view?usp=sharing",
};
